import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'

import moment from 'moment'

class PostDateTag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            data: moment(props.date).fromNow(),
        };

        this.test2 = this.test2.bind(this);
    }

    test2() {
        this.state.data = moment(this.state.date).format("L");
        this.forceUpdate();
    }

    render () {
        return (
            <small onClick={this.test2} style={{textAlign:"right", paddingRight:"6px", display: 'inline-block', width: "100px"}} title={moment(this.state.date).format("YYYY-MM-DD")}>{this.state.data}</small>
        )
    }
}

export default PostDateTag



// WEBPACK FOOTER //
// ../components/PostDateTag.js